import { useCallback } from 'react'
import { useCommand } from './useCommand'
import { useStation } from './TelephonyProvider'
import { TelephonyCommandNames } from '../contract'
import { setLastDialed } from './dial'
import { displayName } from './roster'

// Centralized outbound dial: records last-dialed (for Redial) and issues tel_make_call from the
// bound station. Used by BLF tiles, Contacts, the footer bar, and the dial pad.
export function useDial() {
  const run = useCommand()
  const station = useStation()
  return useCallback((destination: string, opts?: { autoAnswer?: boolean }) => {
    const d = destination.trim()
    if (!d) return
    setLastDialed(d)
    return run(
      {
        command: TelephonyCommandNames.MakeCall,
        params: { extension: station.extension, destination: d, auto_answer: opts?.autoAnswer ?? true }
      },
      { successMessage: `Calling ${displayName(d)}` }
    )
  }, [run, station])
}
